/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';
import { LineType } from '@atlassian/bitkit-diff/exports/types';

type ExpandedLineType = LineType | 'conflict';

type LineGroupProps = {
  type: ExpandedLineType;
  percentHeight: number;
};

const backgroundMap: { [type in ExpandedLineType]: string } = {
  normal: token('elevation.surface'),
  add: token('color.background.success'),
  del: token('color.background.danger'),
  empty: token('color.background.input'),
  loaded: token('elevation.surface'),
  conflict: token('color.background.warning'),
};

export const LineGroup = styled.div<LineGroupProps>(
  ({ type }) => ({
    backgroundColor: backgroundMap[type],
  }),
  ({ percentHeight }) => `height: ${percentHeight}%`,
  {
    width: '10px',
    position: 'relative',
  }
);

// When there are too many lines one line changes don't always show up
// Adding a min-height can make the scroll map too long and lose diffs towards
// the bottom. By adding an absolutely positioned element nested inside each
// line group we can ensure every non-normal line group will respect the
// min-height without pushing lower elements down.
export const FloatingLineGroup = styled.div<{ type: ExpandedLineType }>(
  ({ type }) => ({
    backgroundColor: backgroundMap[type],
    position: 'absolute',
    top: 0,
    minHeight: '2px',
    height: '100%',
    width: '100%',
    visibility: type === 'normal' ? 'hidden' : 'visible',
  })
);

export const ScrollBarWrapper = styled.div<{
  isSideBySide?: boolean;
  scrollbarWidth: number;
}>(({ scrollbarWidth }) => ({
  position: 'absolute',
  top: 0,
  height: '100%',
  right: 0,
  marginRight: `${scrollbarWidth}px`,
  borderLeft: `1px solid ${token('color.border')}`,
}));

export const ScrollBar = styled.div({
  width: '10px',
  height: '100%',
  display: 'inline-block',
});

export const ScrollContent = styled.div<{
  scrollbarWidth: number;
  isSideBySide?: boolean;
}>(({ scrollbarWidth, isSideBySide }) => ({
  height: '100%',
  overflow: 'auto',
  paddingRight: `${scrollbarWidth + (isSideBySide ? 20 : 10)}px`,
}));

export const DiffScrollMap = styled.div({
  position: 'relative',
  height: '100%',
  overflow: 'hidden',
});
